<template>
    <div class="card cart-card shadow-sm">
        <div class="card-header">
            <span class="icon map-icon pr-2"></span>
            <span class="align-text-bottom">
                {{ $t('taxi.components.cart.header') }}
            </span>
        </div>

        <div class="px-3 py-2 text-sm text-muted" v-if="!departureTravel">
            {{ $t('airport_transfers.pages.cart.empty_message') }}
        </div>

        <template v-else>
            <cart-travel
                :label="$t('departure')"
                :departure-date="searchData.departure_date"
                :departure-time="departureTravel.times.departureTime"
                :start-place="searchData.start_place_name"
                :end-place="searchData.end_place_name"
                :travel="departureTravel"
            />

            <cart-travel class="border-top"
                :label="$t('return')"
                :departure-date="searchData.return_date"
                :departure-time="returnTravel.times.departureTime"
                :start-place="searchData.end_place_name"
                :end-place="searchData.start_place_name"
                :travel="returnTravel"
                v-if="returnTravel"
            />

            <div class="bg-body border-top p-3 text-blue-600">
                <div class="d-flex align-items-center justify-content-between font-weight-bold">
                    <div>
                        {{ $t('total') }}:
                    </div>

                    <div class="text-lg">
                        {{ formatPrice(totalCost, currency) }}
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import CartTravel from './CartTravel';

    export default {
        components: {
            CartTravel,
        },

        computed: {
            ...mapGetters({
                searchData: 'airportTransfersSearch/getSearchParameters',
                departureTravel: 'airportTransfersSearch/getDepartureTravel',
                returnTravel: 'airportTransfersSearch/getReturnTravel',
                defaultCurrencyCode: 'constants/getDefaultCurrencyCode',
                totalCost: 'airportTransfersSearch/getTotalCost',
                currency: 'airportTransfersSearch/getCurrency',
            }),
        },
        created() {

        },
    };
</script>
